<template>

    <div class="container-fluid p-0">
        <div class="row widget-grid">

            <!-- form start -->
            <form id="input-form">

                <div 
                class="pb-4 pt-3 pl-2 pr-2 mt-3 mb-3 bg-me-primary border-color-light width-100-p rounded-4"
                :class="{'bg-me-primary': isOdd(scenarioID), 'bg-me-primary-2': isEven(scenarioID)}">

                    <div >
                        <el-row>
                            <!-- new radio box -->
                            <el-col
                             style="align-content: center;" 
                             :span="24"
                             :class="$vuetify.display.width >= 750
                                    ? 'mt-2 ml-3 x-left'
                                    : 'x-center width-100-p mt-2'
                                ">
                                <el-radio-group
                                    v-model="selectParams"
                                    text-color="#ffff"
                                    fill="#234B49"
                                    :class="$vuetify.display.width >= 750 ? '' : 'width-100-p'"
                                >
                                    <el-radio-button
                                    class="start-period all-group-by text-center"
                                    label="LDV"
                                    :class="$vuetify.display.width >= 750 ? '' : 'width-50-p'"
                                    >
                                    LDV
                                    </el-radio-button>
                                    <el-radio-button
                                    class="site-group-by text-center end-period"
                                    label="HDV"
                                    :class="$vuetify.display.width >= 750 ? '' : 'width-50-p'"
                                    >
                                    HDV
                                    </el-radio-button>
                                </el-radio-group>
                            </el-col>

                            <!-- scenario id -->
                            <el-col
                             :class="$vuetify.display.width >= 750
                                    ?  'mt-3 ml-20 x-left'
                                    : 'x-center mt-3'
                                "
                                  :span="$vuetify.display.width >= 750 ? 12 : 24 ">
                                <h5>Scenario {{scenarioID}}</h5>
                            </el-col>

                        </el-row>

                        <el-row>
                            <el-col
                             :class="$vuetify.display.width >= 750 ? 'mt-3 x-left' : 'x-left w-100-p mt-3' "
                             :span="24">
                                <!-- Filter Button -->
                                <estimFilter :key="filterKey" :scenarioId="scenarioID" :applyFilter="applyFilter" ref="childFilter" @updateFilter="updateInputForm" />
                            </el-col>

                            <el-col
                                :class="$vuetify.display.width >= 750
                                        ? 'mt-3 x-left mt-3 px-2'
                                        : 'x-left w-100-p mt-3'
                                    "
                                    :span="$vuetify.display.width >= 750 ? 12 : 24">
                                    <!-- <h5>Scenario {{scenarioID}}</h5> -->
                                    
                                    <el-form-item
                                        v-if="showHDV"
                                        class="label-style"
                                        prop="customer"
                                        :class="$vuetify.display.width >= 750 ? '' : 'mt-3 width-100-p px-2 mb-0'"
                                        >
                                        <label>Site Baseline Params: </label>
                                        <el-select
                                            clearable
                                            v-model="HDV.id"
                                            placeholder="Select Site Baseline Params:"
                                            class="HDV-select w-100"
                                        >
                                            <!-- Render the header row once -->
                                        <template v-if="hdvDropdown.length > 0">
                                            <div class="option-content option-header">
                                                <span class="option-item">Site Name</span>
                                                <span class="option-item">Charging Type</span>
                                                <span class="option-item">AFEC</span>
                                                <span class="option-item">MPG</span>
                                            </div>
                                        </template>
                                            <el-option
                                            v-for="(item, index) in hdvDropdown"
                                            :key="item.id || index"
                                            :label="item.full_name || 'undifined'"
                                            :value="item.id || 'undifined'"
                                            @click="handleSelectHDV(item)"
                                            >
                                            <div class="option-content option-row">
                                                <span class="option-item">
                                                    {{ item.charging_site_title.length > 15 ? item.charging_site_title.substring(0, 15) : item.charging_site_title }}</span>
                                                <span class="option-item">{{ item.charger_type }}</span>
                                                <span class="option-item">{{ item.afec }}</span>
                                                <span class="option-item">{{ item.mpg }}</span>
                                            </div>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                            </el-col>
                
                        </el-row>


                        <el-row v-if="selectParams === 'LDV'" class="m-0 width-100-p mt-3" :gutter="20">
                            <el-col :span="12">
                                <label>Charging type</label>
                                <div  id="charging_checkbox" class="estimator-checkbox" >

                                    <div @click="set_checkBox_ac" >

                                        <el-checkbox v-model="form.showAC" @change="set_checkBox_ac" label="AC" size="large">AC</el-checkbox>

                                    </div>

                                    <div @click="set_checkBox_dc" >
                                        <el-checkbox v-model="form.showDC" @change="set_checkBox_dc" label="DC" :style="'margin-top: 10px'" size="large">DC</el-checkbox>

                                </div>
                                </div>
                            </el-col>

                            <el-col :span="12">

                                <!-- Manual data entry checkbox -->
                                <el-col :span="8">
                                    <div  id="charging_checkbox"  class="estimator-checkbox">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            show-after="500"
                                            hide-after="300"
                                            >
                                            <template #content > <p :style="{fontSize: '12px', width: '300px', textAlign: 'justify'}">If manual data entry is not selected, the annual usage up to the last year of the project will be estimated based on the first year usage and the annual growth rate.</p>  </template>
                                            <div @click="handleApplyUsage" >
                                                <el-checkbox v-model="form.applyUsage" @change="handleApplyUsage" label="Manual Data Entry" class="mt-2">Manual Data Entry</el-checkbox>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                </el-col>

                                <!-- show manual entry button -->
                                <el-col :span="4" v-if="form.applyUsage">
                                    <div  id="charging_checkbox" class="estimator-checkbox">
                                        <div @click="handleShowUsage" >
                                            <el-button
                                                color="#0d3937"
                                                @click.stop="handleShowUsage()"
                                                size="small"
                                                class="me-primary-light"
                                                >
                                                <i class="fa fa-eye"></i>
                                                <span class="pl-1">Show</span>
                                            </el-button>
                                        </div>
                                    </div>
                                </el-col>


                            </el-col>

                            <!-- Location -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? 'x-left mt-2' : 'x-left width-100-p mt-2'">
                                    <div >
                                        <label>Location:</label>
                                        <div>
                                            <el-input
                                                v-model="form.location"
                                                placeholder="Enter Location"
                                                class="mr-2 table-search estimator-input"
                                                size="large"
                                                :disabled="filter.region !== '' || filter.country !== '' ? true : false"
                                                type="string"
                                                required
                                                >
                                            </el-input>
                                            <!-- <input v-model="form.b_gei" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                        </div>
                                    </div>
                            </el-col>


                        </el-row>


                        <!-- basic parameter -->
                        <el-row class="m-0 width-100-p mt-3" :gutter="20"
                            v-if="!form.applyIntensity">

                            <!-- Grid Emission Intensity (tCO2-e/MWh) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div >
                                    <label>Grid emission intensity (tCO2-e/MWh)</label>
                                    <div >
                                        <el-input
                                            size="large"
                                            v-model="form.b_gei"
                                            @input="form.b_gei = handleOninput(form.b_gei)"
                                            @blur="form.b_gei = parseFloat(form.b_gei)"
                                            type="number"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 0.5"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />

                                    </div>
                                </div>
                            </el-col>

                            <!-- Annual Emissions Intensity Improvement (%) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>Annual emission intensity improvement (%)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.b_aeii"
                                            @input="form.b_aeii = handleOninput(form.b_aeii)"
                                            @blur="form.b_aeii = parseFloat(form.b_aeii)"
                                            type="number"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 5"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    </div>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="m-0 width-100-p mt-3" :gutter="20">
                            <!-- Percentage of Onsite Renewables (%) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div>
                                    <label>Percentage of onsite renewables (%)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.b_por"
                                            @input="form.b_por = handleOninput(form.b_por)"
                                            @blur="form.b_por = parseFloat(form.b_por)"
                                            type="number"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 5"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />

                                    </div>
                                </div>
                            </el-col>

                            <!-- Fuel Emission Intensity (tCO2-e/gallon) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>Fuel emission intensity (tCO2-e/gallon)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.b_fei"
                                            @input="form.b_fei = handleOninput(form.b_fei)"
                                            @blur="form.b_fei = parseFloat(form.b_fei)"
                                            type="number"
                                            setp="0.000000000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 0.0087541"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />

                                    </div>
                                </div>
                            </el-col>

                        </el-row>
                        <!-- basic parameter END-->
                    </div>

                </div>

                 <!-- popup window dialog user manual entry data -->
                <div v-if="form.applyUsage && form.showUsage">
                    <el-dialog
                        v-model="form.showUsage"
                        :width="$vuetify.display.width <= 600 ? '100%' : '600'"
                        :fullscreen="$vuetify.display.width <= 600 ? true : false"
                        class="public-style"
                        destory-on-close
                        align-center
                        @close="handleShowUsage"
                    >


                        <el-form
                            :model="usageData"
                            :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
                            :label-position="`top`"
                        >
                            <el-space fill style="width: 100%">
                            <el-alert type="info" class="alert-style" show-icon :closable="false">
                                <p class="ma-0 text-white">Scenario {{scenarioID}} Usage Data:</p>
                            </el-alert>

                            <el-form-item class="applyEmissionIntensity">
                                <!-- manual emission intensity entry checkbox -->
                                <el-row >
                                    <el-col :span="24">
                                        <div id="charging_checkbox" class="estimator-checkbox">
                                            <div @click="handleApplyEmissionIntensity" >
                                                <el-checkbox v-model="form.applyIntensity" @change="handleApplyEmissionIntensity" label="Apply Emission Intensity" class="mt-2">Manual emission intensity entry</el-checkbox>

                                            </div>
                                    </div>
                                    </el-col>
                                </el-row>
                            </el-form-item>



                            <div class="custom-table-design">
                                <el-table :data="this.mergedData" class="mt-3 mb-3 ml-5 data-table" stripe scrollbar-always-on: false style="width: 95%">
                                    <el-table-column prop="year" label="Year" width="100"></el-table-column>

                                    <!-- input form manual usage data -->
                                    <el-table-column label="Usage Data" width="200">
                                    <template v-slot="scope">
                                        <el-input
                                            v-model="scope.row.usageValue"
                                            @input="scope.row.usageValue = handleOninput(scope.row.usageValue)"
                                            @blur="scope.row.usageValue = parseFloat(scope.row.usageValue)"
                                            type="number"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 1000"
                                            class="mr-2 manual-entry-input"
                                            required   />
                                    </template>
                                    </el-table-column>

                                    <!-- input form manual emission intensity data -->
                                    <el-table-column label="Emission Intensity Data" width="230">
                                    <template v-slot="scope">
                                        <el-input
                                            v-model="scope.row.emissionValue"
                                            @input="scope.row.emissionValue = handleOninput(scope.row.emissionValue)"
                                            @blur="scope.row.emissionValue = parseFloat(scope.row.emissionValue)"
                                            type="number"
                                            :disabled="form.applyIntensity ? false : true"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 0.5"
                                            class="mr-2 manual-entry-input"
                                            required
                                                />
                                    </template>
                                    </el-table-column>
                                </el-table>
                            </div>

                            </el-space>
                        </el-form>

                        <!-- manual entry form buttons -->
                        <template #footer>
                            <span class="dialog-footer">
                                <el-button
                                    @click.stop="uploadUsageData"
                                    class="custom-filter-button-apply"
                                >
                                    <svg class="width-111 height-40">
                                    <use href="@/assets/svg/newSvgIcon.svg#customFilterApplyButton"></use>
                                    </svg>
                                </el-button>
                                <el-button
                                    @click.stop="resetUploadUsageData"
                                    class="custom-filter-button-reset"
                                >
                                    <svg class="width-112 height-40">
                                    <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                                    </svg>
                                </el-button>
                                <el-button
                                    @click.stop="handleShowUsage"
                                    class="custom-filter-button-reset"
                                >
                                <svg class="width-112 height-40">
                                    <use href="@/assets/svg/newSvgIcon.svg#tableBackButton"></use>
                                </svg>
                                </el-button>
                            </span>
                        </template>
                    </el-dialog>
                </div>
                <!-- dialog user manual entry data end -->



                <!-- AC charging Parameters -->
                <div>

                    <div v-if="form.showAC" class="pb-4 pl-2 pr-2 mt-3 bg-me-primary border-color-light width-100-p rounded-4"
                    :class="{'bg-me-primary': isOdd(scenarioID), 'bg-me-primary-2': isEven(scenarioID)}">

                        <el-row class="m-0 width-100-p mt-3">
                            <el-col class="d-flex align-item-center px-2" :span="12">
                                <h5 class="text-white mt-3 ml-1">AC charging parameters</h5>
                            </el-col>
                        </el-row>

                        <!-- AC charging parameter -->
                        <el-row class="m-0 width-100-p mt-3" :gutter="20"
                            v-if="!form.applyUsage">
                            <!-- Annual usage (MWh) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div >
                                    <label>Annual usage (MWh)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.ac_au"
                                            @input="form.ac_au = handleOninput(form.ac_au)"
                                            @blur="form.ac_au = parseFloat(form.ac_au)"
                                            type="number"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 1000"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                        <!-- <input v-model="form.ac_au" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                            <!-- Annual Growth in Usage (%) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>Annual growth in usage (%)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.ac_agu"
                                            @input="form.ac_agu = handleOninput(form.ac_agu)"
                                            @blur="form.ac_agu = parseFloat(form.ac_agu)"
                                            type="number"
                                            setp="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 10"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                        <!-- <input v-model="form.ac_agu" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                        </el-row>

                        <el-row class="m-0 width-100-p mt-3" :gutter="20">
                            <!-- MPG (miles/gallon) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div>
                                    <label>{{ MPGACUnit == 'mpg' ? 'MPG (miles/gallon)' : 'KPL (kilometers/liter)' }}</label>
                                    <div>
                                        <!-- <el-input
                                            size="large"
                                            v-model="form.ac_mpg"
                                            @input="form.ac_mpg = handleOninput(form.ac_mpg)"
                                            @blur="form.ac_mpg = parseFloat(form.ac_mpg)"
                                            type="number"
                                            setp="0.000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 30.70828"
                                            class="table-search estimator-input"
                                            required
                                        /> -->
                                    <!-- <input v-model="form.ac_mpg" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.ac_mpg"
                                            @input="form.ac_mpg = handleOninput(form.ac_mpg)"
                                            @blur="form.ac_mpg = parseFloat(form.ac_mpg)"
                                            type="number"
                                            setp="0.000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 30.70828"
                                            class="table-search estimator-input"
                                            required
                                            >
                                            <template #prepend>
                                                <el-select v-model="MPGACUnit" placeholder="Select Unit" style="width: 115px">
                                                <el-option label="MPG" value="mpg" />
                                                <el-option label="KPL" value="kpl" />
                                                </el-select>
                                            </template>
                                        </el-input>
                                    </div>
                                </div>
                            </el-col>

                            <!-- AFEC (kWh/100 miles) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>AFEC (kWh/100 miles)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.ac_afec"
                                            @input="form.ac_afec = handleOninput(form.ac_afec)"
                                            @blur="form.ac_afec = parseFloat(form.ac_afec)"
                                            type="number"
                                            setp="0.000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 28.5809"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    <!-- <input v-model="form.ac_afec" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                        </el-row>

                        <el-row class="m-0 width-100-p mt-3" :gutter="20">
                            <!-- Technology improvement rate -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div>
                                    <label>Technology improvement rate</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.ac_tir"
                                            @input="form.ac_tir = handleOninput(form.ac_tir)"
                                            @blur="form.ac_tir = parseFloat(form.ac_tir)"
                                            type="number"
                                            step="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 1"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    <!-- <input v-model="form.ac_tir" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                            <!-- Charger efficiency -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>Charger efficiency</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.ac_ce"
                                            @input="form.ac_ce = handleOninput(form.ac_ce)"
                                            @blur="form.ac_ce = parseFloat(form.ac_ce)"
                                            type="number"
                                            step="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 100"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    <!-- <input v-model="form.ac_ce" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                        </el-row>
                        <!-- AC charging parameter END -->
                    </div>

                </div>

                <!-- Dc charging Parameters -->
                <div>
                    <div v-if="form.showDC" class="pb-4 pl-2 pr-2 mt-3 bg-me-primary border-color-light width-100-p rounded-4"
                        :class="{'bg-me-primary': isOdd(scenarioID), 'bg-me-primary-2': isEven(scenarioID)}">
                        <el-row class="m-0 width-100-p mt-3">
                            <el-col class="d-flex align-item-center px-2" :span="12">
                                <h5 class="text-white mt-3 ml-1">DC charging parameters</h5>
                            </el-col>
                        </el-row>


                        <!-- DC charging parameter -->
                        <el-row class="m-0 width-100-p mt-3" :gutter="20"
                            v-if="!form.applyUsage">
                            <!-- Annual usage (MWh) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div >
                                    <label>Annual usage (MWh)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.dc_au"
                                            @input="form.dc_au = handleOninput(form.dc_au)"
                                            @blur="form.dc_au = parseFloat(form.dc_au)"
                                            type="number"
                                            step="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 1000"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                        <!-- <input v-model="form.dc_au" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                            <!-- Annual Growth in Usage (%) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>Annual growth in usage (%)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.dc_agu"
                                            @input="form.dc_agu = handleOninput(form.dc_agu)"
                                            @blur="form.dc_agu = parseFloat(form.dc_agu)"
                                            type="number"
                                            step="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 10"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                        <!-- <input v-model="form.dc_agu" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                        </el-row>

                        <el-row class="m-0 width-100-p mt-3" :gutter="20">
                            <!-- MPG (miles/gallon) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div>
                                    <label>{{ MPGDCUnit == 'mpg' ? 'MPG (miles/gallon)' : 'KPL (kilometers/liter)' }}</label>
                                    <div>
                                        <!-- <el-input
                                            size="large"
                                            v-model="form.dc_mpg"
                                            @input="form.dc_mpg = handleOninput(form.dc_mpg)"
                                            @blur="form.dc_mpg = parseFloat(form.dc_mpg)"
                                            type="number"
                                            step="0.000000000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 30.60337"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        /> -->
                                    <!-- <input v-model="form.dc_mpg" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.dc_mpg"
                                            @input="form.dc_mpg = handleOninput(form.dc_mpg)"
                                            @blur="form.dc_mpg = parseFloat(form.dc_mpg)"
                                            type="number"
                                            step="0.000000000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 30.60337"
                                            class="mr-2 table-search estimator-input"
                                            required
                                            >
                                            <template #prepend>
                                                <el-select v-model="MPGDCUnit" placeholder="Select Unit" style="width: 115px">
                                                <el-option label="MPG" value="mpg" />
                                                <el-option label="KPL" value="kpl" />
                                                </el-select>
                                            </template>
                                        </el-input>
                                    </div>
                                </div>
                            </el-col>

                            <!-- AFEC (kWh/100 miles) -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>AFEC (kWh/100 miles)</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.dc_afec"
                                            @input="form.dc_afec = handleOninput(form.dc_afec)"
                                            @blur="form.dc_afec= parseFloat(form.dc_afec)"
                                            type="number"
                                            step="0.000000000000000000001"
                                            style="width: 100%"
                                            placeholder="e.g. 30.30432"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    <!-- <input v-model="form.dc_afec" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                        </el-row>

                        <el-row class="m-0 width-100-p mt-3" :gutter="20">
                            <!-- Technology improvement rate -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24">
                                <div>
                                    <label>Technology improvement rate</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.dc_tir"
                                            @input="form.dc_tir = handleOninput(form.dc_tir)"
                                            @blur="form.dc_tir= parseFloat(form.dc_tir)"
                                            type="number"
                                            step="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 1"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    <!-- <input v-model="form.dc_tir" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                            <!-- Charger efficiency -->
                            <el-col :span="$vuetify.display.width >= 750 ? 12 : 24" :class="$vuetify.display.width >= 750 ? '' : 'mt-3'">
                                <div>
                                    <label>Charger efficiency</label>
                                    <div>
                                        <el-input
                                            size="large"
                                            v-model="form.dc_ce"
                                            @input="form.dc_ce = handleOninput(form.dc_ce)"
                                            @blur="form.dc_ce= parseFloat(form.dc_ce)"
                                            type="number"
                                            step="0.0001"
                                            style="width: 100%"
                                            placeholder="e.g. 92.3"
                                            class="mr-2 table-search estimator-input"
                                            required
                                        />
                                    <!-- <input v-model="form.dc_ce" class="form-control digits" type="number" placeholder="e.g. 10" required> -->
                                    </div>
                                </div>
                            </el-col>

                        </el-row>
                        <!-- DC charging parameter END -->

                    </div>

                </div>

                <!-- Buttons -->
                <div>


                    <div >

                        <el-row class="m-0 width-100-p mt-3">
                            <el-col class="d-flex ml-1 align-item-center">
                                <!-- Apply button -->
                                <el-button
                                    v-if="activeApply <= 1"
                                    @click="submitForm"
                                    class="custom-filter-button-apply"
                                >
                                    <svg class="width-111 height-40">
                                    <use href="@/assets/svg/newSvgIcon.svg#customFilterApplyButton"></use>
                                    </svg>
                                </el-button>
                                <!-- Reset button -->
                                <el-button
                                    @click="resetForm"
                                    class="custom-filter-button-reset"
                                >
                                    <svg class="width-112 height-40">
                                    <use href="@/assets/svg/newSvgIcon.svg#customFilterResetButton"></use>
                                    </svg>
                                </el-button>
                                <!-- Remove button -->
                                <el-button
                                    v-if="scenarioID > 1"
                                    @click="removeForm"
                                    class="custom-filter-button-apply"
                                >
                                <svg class="width-112 height-40">
                                    <use
                                        href="@/assets/svg/newSvgIcon.svg#tableDeleteButton"
                                    ></use>
                                    </svg>
                                </el-button>
                            </el-col>


                        </el-row>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {  mapMutations } from "vuex";
import { ElMessageBox } from "element-plus";

import userService from "@/services/user.service";

import estimFilter from "./estimFilter.vue";


export default{

    // receive scenarioID from index component scenarioid
    props: {
        scenarioID: {
            type: Number,
            required: true
        },
        formData: {
            type: Object,
        },
        activeApply: {
            type: Number,
            required: true
        }
    },

    data(){
        return{
            selectParams: 'LDV', // default select LDV, radio button

            hdvDropdown: [], // HDV dropdown list

            HDV: {
                id: '',
                dhvData: {},
            }, // selected HDV data

            MPGACUnit: 'mpg',
            MPGDCUnit: 'mpg',

            filterKey: 0,

            form: this.formData,

            filter: {
                country: '',
                region: '',
                regionBeforeConvert: '',
            },

            usageData: {
                year0: 0,
                year1: 0,
                year2: 0,
                year3: 0,
                year4: 0,
                year5: 0,
                year6: 0,
                year7: 0,
                year8: 0,
                year9: 0,
                year10: 0,
            }, // for input fields

            emissionIntensity: {
                year0: 0,
                year1: 0,
                year2: 0,
                year3: 0,
                year4: 0,
                year5: 0,
                year6: 0,
                year7: 0,
                year8: 0,
                year9: 0,
                year10: 0,
            }, // for input fields

            showUsageData: [], // usage data array for table

            showEmissionIntensityData: [], // emission intensity data array for table

            mergedData: [], // merged usage data and emission intensity data

            filterData: {},

            }
        },

    computed:  {

        showHDV() {
            if (this.selectParams === 'HDV' && this.filter.region !== '') {
                this.updateHDVDropdownData();
                return true;
            } else {
                this.resetHDVdropdown();

                return false;
            }
        }
    },

    watch: {
        'MPGACUnit': function () {
            this.changeMPGUnit();
        },
        'MPGDCUnit': function () {
            this.changeMPGUnit();
        },

        'selectParams': function (oldVal, newVal) {
            // console.log("selectParams", oldVal, newVal);

            if (oldVal === 'LDV' && newVal === 'HDV') {
                this.$nextTick(() => {
                    this.resetForm();
                    this.filter ={
                        country: '',
                        region: '',
                        regionBeforeConvert: '',
                    };
                });
            }
            if (oldVal === 'HDV' && newVal === 'LDV') {
                this.$nextTick(() => {
                    this.resetForm();
                    this.filter ={
                        country: '',
                        region: '',
                        regionBeforeConvert: '',
                    },
                    this.selectParams = 'HDV';
                    this.resetHDVdropdown();
                });
            }
        },

    },

    components:{
        estimFilter,
    },

    methods: {
        ...mapMutations('estimator', ['set_estimatorData']),
        ...mapMutations('estimator', ['set_ac_and_dc']), // display tables control
        ...mapMutations('estimator', ['set_form']),
        ...mapMutations('estimator', ['set_inputFormData']),

        changeMPGUnit() {
            this.set_form({
                id: this.scenarioID,
                payload: {
                    MPGACUnit: this.MPGACUnit,
                    MPGDCUnit: this.MPGDCUnit,
                }
            });
        },

        // method to convert object to array
        usageDataArray(DataObject) {
            if(this.form.showUsage) {
                try {
                    return Object.keys(DataObject).map((key, index) => ({
                        key: key,
                        year: `Year ${index}`,
                        value: this.usageData[key],
                    }));

                } catch (error) {
                    return [];
                }
            } else {
                return [];
            }
        },

        // method to merge data
        // merge usage data and emission intensity data
        mergeTableData(usageArray, emissionIntensityArray) {
            return usageArray.map((item, index) => ({
                key: item.key,
                year: item.year,
                usageValue: item.value,
                emissionValue: emissionIntensityArray[index].value,
            }));
        },

        // handle Manual Data Entry Show Button
        // convert data to array then merge and display in table
        // update merged data table with data from store
        handleShowUsage() {
            if (this.form.showUsage) {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        showUsage: false,
                    }
                });
            } else {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        showUsage: true,
                    }
                });

                // convert usage data object to array
                let data = this.usageDataArray(this.usageData);
                // this.showUsageData = data;

                // convert emission intensity object to array
                let data2 = this.usageDataArray(this.emissionIntensity);
                // this.showEmissionIntensityData = data2;

                let merge = this.mergeTableData(data, data2);
                this.mergedData = merge; // update merged data table with data from store
            }
        },

        // Manual Data Entry Confirm Button
        // apply inputs from merged table to usageData and emissionIntensity
        // store data to store
        uploadUsageData() {
            this.mergedData.forEach(item => {

            this.usageData[item.key] = item.usageValue;

            this.emissionIntensity[item.key] = item.emissionValue;
        });
        this.set_form({
            id: this.scenarioID,
            payload: {
                usage: this.usageData,
                emission_intensity: this.emissionIntensity,
            }
        });
        this.handleShowUsage(); // close dialog after confirm
        },

        // Manual Data Entry Reset Button
        // reset usage data and emission intensity data at input form reset button
        resetUploadUsageData() {
            const defaultData = {
                year0: 0,
                year1: 0,
                year2: 0,
                year3: 0,
                year4: 0,
                year5: 0,
                year6: 0,
                year7: 0,
                year8: 0,
                year9: 0,
                year10: 0,
            };

            this.usageData = { ...defaultData };
            this.emissionIntensity = { ...defaultData };

            let data = this.usageDataArray(this.usageData);
            this.showUsageData = data; // reset usage data

            let data2 = this.usageDataArray(this.emissionIntensity);
            this.showEmissionIntensityData = data2; // reset emission intensity data

            let merge = this.mergeTableData(data, data2); // reset merged data
            this.mergedData = merge;
        },

        // store apply data to store
        handleApplyUsage() {
            // set applyUsage to false when uncheck manual data entry
            if (this.form.applyUsage) {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        applyUsage: false,
                    }
                });
                // set applyIntensity to false if it is applied when uncheck manual data entry
                if (this.form.applyIntensity) {
                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            applyIntensity: false,
                        }
                    });
                }
            } else {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        applyUsage: true,
                    }
                });
            }
        },

        // store apply data to store
        handleApplyEmissionIntensity() {
            if (this.form.applyIntensity) {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        applyIntensity: false,
                    }
                });
            } else {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        applyIntensity: true,
                    }
                });
            }
        },

        updateFilterKey(){
            this.filterKey++; // reset filter
        },
        // check scenario id is even or odd
        isEven(id) {
            return id % 2 === 0;
        },

        isOdd(id) {
            return id % 2 !== 0;
        },
        // check scenario id is even or odd

    // HDV
        // handle select HDV
        async handleSelectHDV(item){
            // console.log("item", item);
            await this.updateHDVDropdownData();

            if(item.length !== 0){
                this.HDV.id = item.charging_site_title;
                this.HDV.dhvData = item;

                // set ac and dc checkbox
                if (item.charger_type === 'AC') {
                    this.set_checkBox_ac();

                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            showDC: false,
                        }
                    }); // only one type for HDV

                    const selectedData = this.HDV.dhvData;

                    // set form for AC data
                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            b_fei : selectedData.fuel_emission_intensity,
                            ac_afec : selectedData.afec,
                            ac_mpg : selectedData.mpg,
                            ac_ce : selectedData.charger_efficiency * 100,
                            ac_tir : selectedData.tech_improvement_rate,
                        },
                    });

                }

                if (item.charger_type === 'DC') {
                    this.set_checkBox_dc();

                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            showAC: false,
                        }
                    }); // only one type for HDV

                    const selectedData = this.HDV.dhvData;
                    // return console.log(JSON.stringify(filteredBasedata));

                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            b_fei : selectedData.fuel_emission_intensity,
                            dc_afec : selectedData.afec,
                            dc_mpg : selectedData.mpg,
                            dc_ce : selectedData.charger_efficiency * 100,
                            dc_tir : selectedData.tech_improvement_rate,
                        },
                    });
                }

                const { country, region, regionBeforeConvert } = this.filter;

                // console.log("selected HDV country", country);
                // console.log("selected HDV region", region);
                // console.log("selected HDV regionBeforeConvert", regionBeforeConvert);

                const dataAU = this.filterData.AU[region];
                const dataUK = this.filterData.UK[region];

                if (country === 'UK'){

                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            b_gei : dataUK, // base Grid Emission Intensity
                            // add region as location into form
                            location : regionBeforeConvert,
                        },
                    });
                }
                if (country === 'AU'){

                    this.set_form({
                        id: this.scenarioID,
                        payload: {
                            b_gei : dataAU, // base Grid Emission Intensity
                            // add region as location into form
                            location : regionBeforeConvert,
                        },

                    });

                }

            }
            // console.log("selected HDV", this.HDV);
        },

        async updateHDVDropdownData(){
            const data = await this.filterData.site_baseline_list;
            // console.log("data", data);
            let country = this.filter.country.toUpperCase();
            // console.log("country", country);
            let result = data.filter(item => item.country.toUpperCase() === country);
            // console.log("result", result);
            this.hdvDropdown = result;
            // console.log("hdvDropdown", this.hdvDropdown);
        },

        resetHDVdropdown(){
            this.HDV.id = '';
            this.HDV.dhvData = {};
        },
    // HDV

        set_checkBox_ac() {
            if (this.form.showAC) {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        showAC: false,
                    }
                });
            } else {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        showAC: true,
                    }
                });
            }

            this.onCheckboxChange();
        },

        set_checkBox_dc() {
            if (this.form.showDC) {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        showDC: false,
                    }
                });
            } else {
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        showDC: true,
                    }
                });
            }

            // troger checkbox change again when location changed
            this.onCheckboxChange();
        },


        filterBaseData(database, country, chargingType) {
            return database.filter(
                item =>
                item.country === country.toUpperCase() &&
                item.charger_type === chargingType
            );
        },

        resetFilter(){
            this.filter = {
                country: '',
                region: '',
                regionBeforeConvert: '',
            };
            this.updateFilterKey();
            this.$refs.childFilter.resetCountry();
        },

        updateInputForm(childForm){
            // console.log(childForm);
            this.filter.country = childForm.country;
            this.filter.region = childForm.region;
            this.filter.regionBeforeConvert = childForm.regionBeforeConvert;
            // console.log(this.filter);
            },

        onCheckboxChange() {

            // check if filter  is applied
            if (this.filter.country == "" && this.filter.region == "") {
                // this.checkBoxtoForm();
                return
            } else {
                // this.checkBoxtoForm();
                if (this.selectParams === 'LDV') {
                    this.applyFilter('chargingType');
                }
                if (this.selectParams === 'HDV') {
                    return
                }
            }
        },

        applyFilter(option) {

            if (this.filter) {

            try {

            const { country, region, regionBeforeConvert } = this.filter;
            const data = this.filterData;


            // handle apply filter when choose charging type
            if (option === 'chargingType' && this.form.showAC){

                let basedata = data.base_data;
                let filteredBasedata = this.filterBaseData(basedata, country, "AC");
                const selectedData = filteredBasedata[0];

                this.set_form({
                    id: this.scenarioID,


                    payload: {

                        b_fei : selectedData.fuel_emission_intensity,
                        ac_afec : selectedData.afec,
                        ac_mpg : selectedData.mpg,
                        ac_ce : selectedData.charger_efficiency * 100,
                        ac_tir : selectedData.tech_improvement_rate,

                    },

                });

            }

            // handle apply filter when choose charging type
            if (option === 'chargingType' && this.form.showDC){

                let basedata = data.base_data;
                let filteredBasedata = this.filterBaseData(basedata, country, "DC");
                const selectedData = filteredBasedata[0];
                // return console.log(JSON.stringify(filteredBasedata));

                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        b_fei : selectedData.fuel_emission_intensity,
                        dc_afec : selectedData.afec,
                        dc_mpg : selectedData.mpg,
                        dc_ce : selectedData.charger_efficiency * 100,
                        dc_tir : selectedData.tech_improvement_rate,
                    },
                });

            }



            // handle apply filter when choose location is UK
            if (option === 'location' && country === 'UK'){
                let ukdata = data.UK;
                // return console.log(region,ukdata);
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        b_gei : ukdata[region], // base Grid Emission Intensity
                        // add region as location into form
                        location : regionBeforeConvert,
                    },

                });

            }

            // handle apply filter when choose location Is AU
            if (option === 'location' && country === 'Australia'){
                let audata = data.AU;
                // return console.log(region,audata);
                this.set_form({
                    id: this.scenarioID,
                    payload: {
                        b_gei : audata[region], // base Grid Emission Intensity

                        // add region as location into form
                        location : regionBeforeConvert,
                    },

                });

            }

            // call check box change when click on filter
            this.onCheckboxChange();

            } catch (error) {
                return console.log("error when apply filter", error);
            }
        } else {
            return console.log("filter is not apply");
        }

        },

        // handle input value check: to be number and decimal, cannot be negative
        handleOninput(value){
            let str = value;
            let len1 = str.substr(0, 1);
            let len2 = str.substr(1, 1);

            // If the first character is '0' and the second is not '.', replace the first '0'
            if (str.length > 1 && len1 == 0 && len2 != ".") {
                str = str.substr(1, 1);
            }

            // The first character cannot be '.' or '+' or '-'
            if (len1 == "." || len1 == "+" || len1 == "-") {
                ElMessageBox.alert(
                    '<strong><span>Inputs cannot be negative!</span></strong>',
                    'Invalid Inputs',
                    {
                    dangerouslyUseHTMLString: true,
                    }
                ).then(()=> {return;}).catch(()=>{return;});
                // alert("Inputs cannot be negative!");
                str = "";
            }

            // Only one decimal point is allowed
            if (str.indexOf(".") != -1) {
            let str_ = str.substr(str.indexOf(".") + 1);
            if (str_.indexOf(".") != -1) {
                str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
            }
            }

            // Keep only numbers and decimal points
            return str.replace(/[^\d.]+/g, "");
        },
        // handle input value to be number and decimal, cannot be negative

        // handle MPG unit change
        handleMPGUnitChange(unit, value) {
            if (unit == 'mpg') {
                return value
            } else {
                return value * 2.35214583;
            }
        },

        // check if form is all filled before submite
        isFormFilled() {
            const basicFieldsFilled = this.validateBasicFields();

            // console.log("basicFieldsFilled", basicFieldsFilled);


            if (this.form.showAC && !this.form.showDC) {
                return basicFieldsFilled && this.validateACFields();
            }

            if (this.form.showDC && !this.form.showAC) {
                return basicFieldsFilled && this.validateDCFields();
            }

            if (this.form.showAC && this.form.showDC) {
                return basicFieldsFilled && this.validateACFields() && this.validateDCFields();
            }
            // check if form is all filled before submite

            // Return false if neither AC nor DC is selected
            return false;
    },

            validateBasicFields() {
                // console.log("form", this.form);

                // Check if basic fields (b_) are filled
                if(this.form.location === ''){
                    return false;
                } else {
                    return this.form.b_gei !== '' && this.form.b_aeii !== '' && this.form.b_por !== null && this.form.b_fei !== '';
                }
            },

            validateACFields() {
                // Check if AC fields (ac_) are filled
                return this.form.ac_au !== '' && this.form.ac_agu !== '' && this.form.ac_mpg !== '' && this.form.ac_afec !== '' && this.form.ac_tir !== '' && this.form.ac_ce !== '';
            },

            validateDCFields() {
                // Check if DC fields (dc_) are filled
                return this.form.dc_au !== '' && this.form.dc_agu !== '' && this.form.dc_mpg !== '' && this.form.dc_afec !== '' && this.form.dc_tir !== '' && this.form.dc_ce !== '';
            },

        // check if form is all filled before submite


        async submitForm() {
            this.form.ac_mpg = this.handleMPGUnitChange(this.MPGACUnit, this.form.ac_mpg);
            this.form.dc_mpg = this.handleMPGUnitChange(this.MPGDCUnit, this.form.dc_mpg);



            if (!this.form.showAC && !this.form.showDC ) {
                // alert("Charging type is missing!");
                ElMessageBox.alert(
                    '<strong><span>Charging type is missing!</span></strong>',
                    'Invalid Inputs',
                    {
                    dangerouslyUseHTMLString: true,
                    }
                ).then(()=> {return;}).catch(()=>{return;});
            }
            else {

                this.set_ac_and_dc({ showAC: this.form.showAC, showDC: this.form.showDC }); // control display table for ac/dc or both

                if(this.isFormFilled()) {

                    this.set_inputFormData(this.form);

                await userService.DashboardEstimator(this.form).then(


                    (res) => {
                        // console.log(this.form);
                        if (res.data != null) {
                            // console.log(res.data);
                            res.data.scenario_id = this.scenarioID;
                            // console.log(res.data);
                            this.set_estimatorData(res.data);
                        } else {
                            console.log("empty response data, check error");
                        }
                    }
                ).then(
                    (res) => {
                        this.$emit('submitForm');
                        return res;
                    }
                ).catch((err)=>{
                    console.log("error message: ", err);
                    if (err.response.statusText
                    == "Bad Request") {
                        // this.$router.push({
                        // path: "/",
                        // });
                        return ElMessageBox.alert(
                        '<strong><span>Bad Request, Check inputs!</span></strong>',
                         'Invalid Inputs',
                        { dangerouslyUseHTMLString: true,}).then(()=> {return;}).catch(()=>{return;});
                    }
                }).finally(()=>{
                    console.log("request done");
                });
                } else {
                    return ElMessageBox.alert(
                    '<strong><span>Some required fields in the form are missing!</span></strong>',
                    'Invalid Inputs',
                    {dangerouslyUseHTMLString: true,}).then(()=> {return;}).catch(()=>{return;});
                }
            }
        },


        // reset input form
        resetForm() {
            this.resetUploadUsageData();

            this.resetFilter(); // reset filter by update filter key

            this.selectParams = 'LDV'; // reset HDV data and radio box: select LDV, radio button

            this.$emit('resetForm');
                },

        // remove scenario of input form
        removeForm() {
            this.$emit('removeForm');
        }

    },

    // fetching filter data when component is mounted
        // site_baseline_params, baseline_params, UK, AU intensity data
    async mounted(){
        // check if have filter data at session storage, aviod duplicate requests
        const data = sessionStorage.getItem("estimatorLocationFilter");
        if (data && data.length > 0) {
            this.filterData = JSON.parse(data);
            return;
        } else {
            // if no data found, send request to get data
            await userService.DashboardEstimatorFilter().then(
            (res) => {
                // console.log("res.data", res.data);
                this.filterData = res.data;
                sessionStorage.setItem(
                    "estimatorLocationFilter",
                    JSON.stringify(this.filterData)
                );
                // console.log("filter data", this.filterData);
            }
            );
        }
    },


}
</script>

<style scoped>
.applyEmissionIntensity :deep(.el-form-item__content) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    line-height: 32px;
    position: relative;
    font-size: var(--font-size);
    min-width: 0;
    justify-content: start;
    padding-left: 20px;
}

h2 {
    color: white;
}
h5 {
    color: white;
}

label{
    color: white;
    font-size:medium;
}
.checkbox{
    /* margin-right: 11.17px;
    width: 30px;
    height: 16px; */
    display: none;
}
.checkboximg{
    width: 18px;
    height: 18px;
    margin-right: 7px;
    position: relative;
}
  
  .el-dropdown-menu {
    background-color: #0d3937 !important;
    color: white !important;
  }

  .el-dropdown-menu__item {
    color: white !important;
  }

  .el-dropdown-menu__item:not(.is-disabled):focus {
    background-color: #547477 !important;
  }

  .label-color > label {
    color: white !important;
    width: 80px !important;
  }
  .label-color > div > div {
    height: 100% !important;
    display: flex !important;
    align-items: center;
  }

  .el-dropdown__list > .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }
  
  .option-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .option-header {
    font-weight: bold;
    color: blue;
    background-color: #f2f2f2;

    position: sticky;
    top:0;
    z-index: 1;

  }

  .option-item {
    color: var(--el-text-color-secondary);
    font-size: 13px;
    flex: 1;
    text-align: center;
    padding: 4px;
  }

  .warning-message {
  color: orangered;
  font-size: 12px;
  padding: 2px;
  border-radius: 5px;
}

.radio-label {
  color: #ffffff;
  display: flex;
  align-items: center;
  height: 100%;
}

.estimator-checkbox :deep(.el-checkbox__input.is-checked+.el-checkbox__label) {
    color: #fff;
}

.estimator-checkbox :deep(.el-checkbox.el-checkbox--large) {
    height: 20px;
    margin-bottom: 0px;
}

.estimator-checkbox :deep(.el-checkbox__inner) {
    display: inline-block;
    position: relative;
    border: var(--el-checkbox-input-border);
    border-radius: 2px;
    box-sizing: border-box;
    width: var(--el-checkbox-input-width);
    height: var(--el-checkbox-input-height);
    background-color: #0D3937;
    z-index: var(--el-index-normal);
    transition: border-color .25scubic-bezier(.71,-.46,.29,1.46), background-color .25scubic-bezier(.71,-.46,.29,1.46), outline .25scubic-bezier(.71,-.46,.29,1.46);
}

.estimator-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #547477;
    border-color: #FFF;
}


</style>
